// Announcements: public active + responses + admin CRUD.
// Backend: `edge-api/src/routes/announcements.ts`.
import { apiCall } from "./core";

export const announcementAPI = {
  /** Most recent active announcement targeting this user. */
  fetchActive: async (token) => {
    if (!token) {
      throw new Error("Auth token required");
    }
    const headers = { Authorization: `Bearer ${token}` };
    return await apiCall("/announcements/active", { headers });
  },

  /** Record a response (response | dismissed | acknowledged) to an announcement. */
  submitResponse: async ({ token, announcementId, payload }) => {
    if (!token) {
      throw new Error("Auth token required");
    }
    if (!announcementId) {
      throw new Error("announcementId is required");
    }
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    return await apiCall(`/announcements/${announcementId}/responses`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload || {}),
    });
  },

  adminList: async ({ token, activeOnly = false, audience, limit } = {}) => {
    if (!token) {
      throw new Error("Auth token required");
    }
    const params = new URLSearchParams();
    if (activeOnly) params.append("active_only", "true");
    if (audience) params.append("audience", audience);
    if (typeof limit === "number") params.append("limit", String(limit));
    const headers = { Authorization: `Bearer ${token}` };
    const qs = params.toString();
    return await apiCall(`/admin/announcements${qs ? `?${qs}` : ""}`, {
      headers,
    });
  },

  adminCreate: async ({ token, payload }) => {
    if (!token) {
      throw new Error("Auth token required");
    }
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    return await apiCall("/admin/announcements", {
      method: "POST",
      headers,
      body: JSON.stringify(payload || {}),
    });
  },

  adminUpdate: async ({ token, announcementId, payload }) => {
    if (!token) {
      throw new Error("Auth token required");
    }
    if (!announcementId) {
      throw new Error("announcementId is required");
    }
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    return await apiCall(`/admin/announcements/${announcementId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(payload || {}),
    });
  },

  adminDelete: async ({ token, announcementId }) => {
    if (!token) {
      throw new Error("Auth token required");
    }
    if (!announcementId) {
      throw new Error("announcementId is required");
    }
    const headers = { Authorization: `Bearer ${token}` };
    return await apiCall(`/admin/announcements/${announcementId}`, {
      method: "DELETE",
      headers,
    });
  },
};
